(function() {
    'use strict';
    angular.module('app')
        .controller('AdministrationController', function($scope, $location) {})
})();


// WEBPACK FOOTER //
// ./js/controllers/AdministrationController.js